import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import ProductDetails from '../views/ProductDetails.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },{
    path: '/product/:name/:class',
    name: 'product',
    component: ProductDetails
  },{
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },{
    path: '/class/:name',
    name: 'class',
    component: () => import(/* webpackChunkName: "about" */ '../views/ProductClass.vue')
  },{
    path: '/honor',
    name: 'honor',
    component: () => import(/* webpackChunkName: "about" */ '../views/HonorView.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 对于前进/后退按钮，返回之前保存的位置
    } else {
      return { top: 0 }; // 否则滚动到页面顶部
    }
  },
})

export default router
